import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function SAMPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Materials and Methods</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <ul>
              <p>
                <strong>21.2.1 Study Area</strong>
              </p>
              <p>
                Karnataka is located between 11-18<sup>0</sup> N latitudes and
                74-78<sup>0 </sup>E longitudes with an area of 1, 91,790 km
                <sup>2</sup>. It accounts, 5.8 % of the total geographic area of
                India, with 300 km coastline. Karnataka has 38,284 km
                <sup>2</sup> forest area, supporting diverse biodiversity
                because of its great variability in climate, topography, and
                soil. It has around 10% of tiger and 25% of the elephant
                population of the country. The State has diverse species of
                flora and fauna evident from the occurrence of 4500+ species of
                flowering plants, 600 bird species, 160 species each of mammal
                and reptiles, 800 species of fish, 70 species of frogs, etc. The
                region is endowed with the major rivers such as Krishna, Cauvery
                (east-flowing), Sharavathi, Netravathi, Kali, Aghnashini,
                Chakra, and Varahi (West flowing). The Western Ghats alone
                covers around 60% of total forests of the state. Figure 1
                illustrates the location of various PAs in Karnataka accounting
                16 % of forest area under protection. The State has 6 National
                Parks (NP), 23 Wild Life Sanctuaries (WLS), one biosphere
                reserve and one community reserve. These regions are under
                various levels of ecological stress due to the escalation of
                unplanned and unrealistic developmental activities with the
                mismanagement of resources during the post-independence period.
              </p>
              <p style={{ textAlign: "center" }}>
                {" "}
                <img src="images/vds1.jpg" alt="" />{" "}
              </p>
              <br />
              <p style={{ textAlign: "center" }}>
                <strong>Fig. 21.1</strong> Protected Areas in the Karnataka
                State
              </p>
              
              <p>
                <strong>21.2.2 Method</strong>
              </p>
              <p>
                Figures 21. 2 and 21.3 outline the framework and method involved
                in designing a spatial decision support system for sustainable
                management of protected areas in Karnataka (SDSS-KPA). SDSS was
                developed in the Cento Linux environment (http://www.centos.org)
                using Free and Open Source Software for Geoinformatics (FOSS4G)
                such as GeoServer (http://geoserver.org/download), PostgreSQL
                (http://postgresql.org), Post GIS (http://postgis.net), Apache
                Tomcat web server (http://tomcat.apache.org). Database (spatial
                and attribute data) management is achieved through FOSS
                PostgreSQL and Post GIS (Brovelli and Magni, 2003). GeoServer is
                an open-source software server written in Java that allows users
                to share, edit, publish geospatial data and runs in an
                integrated Apache Tomcat Web server environment. This includes
                implementation of the Open Geospatial Consortium (OGC) standards
                (http<em>://</em>www.opengeospatial.org/standards;
                http://www.opengeospatial.org/blog/2034) such as Web Feature
                Service (WFS) and Web Coverage Service (WCS) standards, Web Map
                Service (WMS) that are is integrated in client-server
                architecture with the request and response process through a
                simple HTTP interface OpenLayers (http://openlayers.org), which
                is open source JavaScript API &nbsp;integrated as a default map
                environment that renders dynamic maps over the web a for
                visualization of spatial data in a web browser. &nbsp;The
                integration of numerous datasets has been possible through the
                default store options of GeoServer.
              </p>
              <p style={{ textAlign: "center" }}>
                {" "}
                <img src="images/vds2.png" alt="" />{" "}
              </p>
              
              <p style={{ textAlign: "center" }}>
                <strong>Fig. 21.2 </strong>Spatial Decision Support System
                Framework for prudent management of PAs in Karnataka.
              </p>
              <p style={{ textAlign: "center" }}>
                {" "}
                <img src="images/vds3.png" alt="" />{" "}
              </p>
             
              <p style={{ textAlign: "center" }}>
                <strong>Fig. 21.3 P</strong>rotocol for the design of KPASDSS
                for visualisation of natural resources in PAs
              </p>
              <p>
                Land use dynamics of PAs were assessed by classifying temporal
                remote sensing data with training data (collected from the field
                and online portal &ndash; Google, Bhuvan) using a supervised
                classifier based on GMLC. Vector data include the administrative
                boundaries with the associated attribute information. These
                vector and raster datasets were imported to GeoServer for
                visualisation with OGC web services. Geo-visualization with the
                modeling capability helps explore the complex behaviour of
                agents (Bharath et al., 2014), which helps understand the causes
                and consequences of changes. Modelling and prediction have been
                useful in evolving appropriate mitigation measures with an
                accurate assessment of likely LULC changes, the drivers of
                changes, and likely impacts on the ecosystem, etc. (Haase and
                Schwarz, 2009). The Markov based Cellular Automata (CA-Markov)
                modelling technique has been implemented by computing transition
                probability and transition areas matrices based on earlier land
                uses. Accurate assessment and validation of the prediction is
                done by comparing the simulated land use (2016) with the actual
                land uses (2016) and computation of kappa statistics. Based on
                the better accuracy, the projection with same technique is made
                for predicting likely changes in 2026.
              </p>
            </ul>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default SAMPage;
